import React, {useMemo} from "react";
import {Typography} from "antd";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {useTranslate} from "../../../../hooks/translate.hook";
import {HealthCheckerIssue} from "../../../../models/health-checker/health-checker";
import {healthCheckerService} from "../../../../services/health-checker/health-checker.service";
import {columnsFactory} from "./issues.columns";
import {SmartTable} from "../../../common/smart-table/smart-table";
import {SmartTableDataHandler} from "../../../common/smart-table/smart-table.data-handler";
import {useNavigate} from "react-router";
import "./issues.scss";

const {Text, Title} = Typography;

export const HealthCenterIssues: React.FC<ComponentPropsFromRoute> = () => {
    const t = useTranslate();
    const navigate = useNavigate();
    const columns = useMemo(() => columnsFactory(t), [t]);
    const handler = useMemo(
        () => new SmartTableDataHandler<HealthCheckerIssue>((request) => healthCheckerService.getIssues(request)),
        []
    );

    return (
        <section className="health-center-issues">
            <div className="health-center-issues__header">
                <Title level={4}>
                    {t("HEALTH-CENTER.ISSUES.LIST-TITLE", {defaultValue: "Health check issues"})}
                </Title>
                <Text type="secondary">
                    {t("HEALTH-CENTER.ISSUES.LIST-DESCRIPTION", {
                        defaultValue: "Detected issues and their latest incidents",
                    })}
                </Text>
            </div>

            <SmartTable
                columns={columns}
                handler={handler}
                actions={[
                    {
                        icon: "eye",
                        title: t("HEALTH-CENTER.ISSUES.OPEN", {defaultValue: "Open issue"}),
                        onClick: (issue) => navigate(`/health-center/issues/${issue.id}`),
                    },
                ]}
            />
        </section>
    );
};
